const EVENT_TYPES = Object.freeze({
    USER_ID: 'userId',
    USER_PROPERTIES: 'userProperties',
    SIGN_IN_PAGE_VISITED: 'signInPageView',
    HOMEPAGE_VISITED: 'homepageVisited',
    SALE_CHECKOUT_CLICK_PAY: 'sale_checkout_click_pay',
    SUCCESS_STATUS_VIEWED: 'success_status_viewed',
    ABOUT_US_PAGE_VISITED: 'app_about_us_page_visited',
    CANCEL_SUBSCRIPTION_BUTTON_CLICKED: 'app_cancel_subscription_button_clicked',
    DELETE_ACCOUNT_BUTTON_CLICKED: 'app_delete_account_button_clicked',
    SIGN_OUT_CLICKED: 'app_sign_out_clicked',
    ACCOUNT_HEADER_LINK_CLICKED: 'app_account_header_link_clicked',
    PREMIUM_PAGE_VISITED: 'app_premium_page_visited',
    SUPPORT_EMAIL_CLICKED: 'app_support_email_clicked',
    SUPPORT_PHONE_CLICKED: 'app_support_phone_clicked',
    DASHBOARD_PAGE_VISITED: 'app_dashboard_page_visited',
    PREMIUM_BUTTON_CLICKED: 'app_premium_button_clicked',
    PREMIUM_INITIATE_CHECKOUT: 'app_premium_initiate_checkout',
    SUPPORT_WIDGET_CLICKED: 'app_support_widget_clicked',
    SUPPORT_SEND_CLICKED: 'app_support_send_clicked',
    SUPPORT_ERROR_VIEWED: 'app_support_error_viewed',
    SUBSCRIPTION_PAGE_VISITED: 'app_subscription_page_visited',
    PURCHASES_PAGE_VISITED: 'app_purchases_page_visited',
    PAYMENT_HISTORY_PAGE_VISITED: 'app_payment_history_page_visited',
    DELETE_ACCOUNT_PAGE_VISITED: 'app_delete_account_page_visited',
    HELP_CENTER_CLICKED: 'app_help_center_clicked',
    SIGN_IN_EMAIL_INPUT_SUCCESSFUL: 'app_sign_in_email_input_successful',
    SIGN_IN_EMAIL_INPUT_FAILED: 'app_sign_in_email_input_failed',
    SIGN_IN_OTP_REQUEST_VIEWED: 'app_sign_in_otp_request_viewed',
    SIGN_IN_OTP_VIEWED: 'app_sign_in_otp_viewed',
    SIGN_IN_OTP_FAILED: 'app_sign_in_otp_failed',
    SIGN_IN_OTP_RESENT: 'app_sign_in_otp_resent',
    SIGN_IN_HELP_CLICKED: 'app_sign_in_help_clicked',
    SIGN_IN_BACK_CLICKED: 'app_sign_in_back_clicked',
    SIGN_IN_EXPIRED_LINK_VIEWED: 'app_sign_in_expired_link_viewed',
    CALL_ME_BACK_CLICKED: 'app_call_me_back_clicked',
    CALL_ME_BACK_SUBMITTED: 'app_call_me_back_submitted',
    CONTACT_US_BUTTON_CLICKED: 'app_contact_us_button_clicked',
    CONTACT_US_PAGE_VISITED: 'app_contact_us_page_visited',
    DASHBOARD_STATUS_CARD_VIEWED: 'app_dashboard_status_card_viewed',
    DASHBOARD_CONTACT_BLOCK_VIEWED: 'app_dashboard_contact_block_viewed',
    DASHBOARD_FEATURE_CARD_VIEWED: 'app_dashboard_feature_card_viewed',
    VIEW_PLAN_CLICKED: 'app_view_plan_clicked',
    APP_ERROR_VIEWED: 'app_error_viewed',
    MEMORY_KEEPER_CHAT_PAGE_VISITED: 'app_memory_keeper_chat_page_visited',
    MEMORY_KEEPER_MEMORIES_PAGE_VISITED: 'app_memory_keeper_memories_page_visited',
    MEMORY_KEEPER_SHARE_PAGE_VISITED: 'app_memory_keeper_share_page_visited',
    MEMORY_KEEPER_CHAPTER_SELECTED: 'app_memory_keeper_chapter_selected',
    MEMORY_KEEPER_CHAT_FINISHED_VIEWED: 'app_memory_keeper_chat_finished_viewed',
    MEMORY_KEEPER_MEMORY_SAVED: 'app_memory_keeper_memory_saved',
    MEMORY_KEEPER_MEMORY_VIEWED: 'app_memory_keeper_memory_viewed',
    MEMORY_KEEPER_CHAPTERS_LOAD_ERROR_VIEWED: 'app_memory_keeper_chapters_load_error_viewed',
    MEMORY_KEEPER_CHAT_LOAD_ERROR_VIEWED: 'app_memory_keeper_chat_load_error_viewed',
    MEMORY_KEEPER_RETRY_CLICKED: 'app_memory_keeper_retry_clicked',
    MEMORY_KEEPER_BOOK_INTEREST_CLICKED: 'app_memory_keeper_book_interest_clicked',
    MEMORY_KEEPER_SHARE_INTEREST_CLICKED: 'app_memory_keeper_share_interest_clicked',
    MEMORY_KEEPER_ONBOARDING_FINISHED: 'app_memory_keeper_onboarding_finished',
    MEMORY_KEEPER_ONBOARDING_CLOSED: 'app_memory_keeper_onboarding_closed',
    MEMORY_KEEPER_ONBOARDING_STEP_VIEWED: 'app_memory_keeper_onboarding_step_viewed'
});

const AMPLITUDE_EVENT_TYPES = Object.freeze({
    [EVENT_TYPES.SIGN_IN_PAGE_VISITED]: 'app_sign_in_page_visited',
    [EVENT_TYPES.HOMEPAGE_VISITED]: 'app_homepage_visited',
    [EVENT_TYPES.SALE_CHECKOUT_CLICK_PAY]: 'sale_checkout_click_pay',
    [EVENT_TYPES.SUCCESS_STATUS_VIEWED]: 'app_success_status_viewed',
    [EVENT_TYPES.ABOUT_US_PAGE_VISITED]: 'app_about_us_page_visited',
    [EVENT_TYPES.CANCEL_SUBSCRIPTION_BUTTON_CLICKED]: 'app_cancel_subscription_button_clicked',
    [EVENT_TYPES.DELETE_ACCOUNT_BUTTON_CLICKED]: 'app_delete_account_button_clicked',
    [EVENT_TYPES.SIGN_OUT_CLICKED]: 'app_sign_out_clicked',
    [EVENT_TYPES.ACCOUNT_HEADER_LINK_CLICKED]: 'app_account_header_link_clicked',
    [EVENT_TYPES.PREMIUM_PAGE_VISITED]: 'app_premium_page_visited',
    [EVENT_TYPES.SUPPORT_EMAIL_CLICKED]: 'app_support_email_clicked',
    [EVENT_TYPES.SUPPORT_PHONE_CLICKED]: 'app_support_phone_clicked',
    [EVENT_TYPES.DASHBOARD_PAGE_VISITED]: 'app_dashboard_page_visited',
    [EVENT_TYPES.PREMIUM_BUTTON_CLICKED]: 'app_premium_button_clicked',
    [EVENT_TYPES.PREMIUM_INITIATE_CHECKOUT]: 'app_premium_initiate_checkout',
    [EVENT_TYPES.CALL_ME_BACK_CLICKED]: 'app_call_me_back_clicked',
    [EVENT_TYPES.CALL_ME_BACK_SUBMITTED]: 'app_call_me_back_submitted',
    [EVENT_TYPES.SUPPORT_WIDGET_CLICKED]: 'app_support_widget_clicked',
    [EVENT_TYPES.SUPPORT_SEND_CLICKED]: 'app_support_send_clicked',
    [EVENT_TYPES.SUPPORT_ERROR_VIEWED]: 'app_support_error_viewed',
    [EVENT_TYPES.SUBSCRIPTION_PAGE_VISITED]: 'app_subscription_page_visited',
    [EVENT_TYPES.PURCHASES_PAGE_VISITED]: 'app_purchases_page_visited',
    [EVENT_TYPES.PAYMENT_HISTORY_PAGE_VISITED]: 'app_payment_history_page_visited',
    [EVENT_TYPES.DELETE_ACCOUNT_PAGE_VISITED]: 'app_delete_account_page_visited',
    [EVENT_TYPES.HELP_CENTER_CLICKED]: 'app_help_center_clicked',
    [EVENT_TYPES.SIGN_IN_EMAIL_INPUT_SUCCESSFUL]: 'app_sign_in_email_input_successful',
    [EVENT_TYPES.SIGN_IN_EMAIL_INPUT_FAILED]: 'app_sign_in_email_input_failed',
    [EVENT_TYPES.SIGN_IN_OTP_REQUEST_VIEWED]: 'app_sign_in_otp_request_viewed',
    [EVENT_TYPES.SIGN_IN_OTP_VIEWED]: 'app_sign_in_otp_viewed',
    [EVENT_TYPES.SIGN_IN_OTP_FAILED]: 'app_sign_in_otp_failed',
    [EVENT_TYPES.SIGN_IN_OTP_RESENT]: 'app_sign_in_otp_resent',
    [EVENT_TYPES.SIGN_IN_HELP_CLICKED]: 'app_sign_in_help_clicked',
    [EVENT_TYPES.SIGN_IN_BACK_CLICKED]: 'app_sign_in_back_clicked',
    [EVENT_TYPES.SIGN_IN_EXPIRED_LINK_VIEWED]: 'app_sign_in_expired_link_viewed',
    [EVENT_TYPES.CONTACT_US_BUTTON_CLICKED]: 'app_contact_us_button_clicked',
    [EVENT_TYPES.CONTACT_US_PAGE_VISITED]: 'app_contact_us_page_visited',
    [EVENT_TYPES.DASHBOARD_STATUS_CARD_VIEWED]: 'app_dashboard_status_card_viewed',
    [EVENT_TYPES.DASHBOARD_CONTACT_BLOCK_VIEWED]: 'app_dashboard_contact_block_viewed',
    [EVENT_TYPES.DASHBOARD_FEATURE_CARD_VIEWED]: 'app_dashboard_feature_card_viewed',
    [EVENT_TYPES.VIEW_PLAN_CLICKED]: 'app_view_plan_clicked',
    [EVENT_TYPES.APP_ERROR_VIEWED]: 'app_error_viewed',
    [EVENT_TYPES.MEMORY_KEEPER_CHAT_PAGE_VISITED]: 'app_memory_keeper_chat_page_visited',
    [EVENT_TYPES.MEMORY_KEEPER_MEMORIES_PAGE_VISITED]: 'app_memory_keeper_memories_page_visited',
    [EVENT_TYPES.MEMORY_KEEPER_SHARE_PAGE_VISITED]: 'app_memory_keeper_share_page_visited',
    [EVENT_TYPES.MEMORY_KEEPER_CHAPTER_SELECTED]: 'app_memory_keeper_chapter_selected',
    [EVENT_TYPES.MEMORY_KEEPER_CHAT_FINISHED_VIEWED]: 'app_memory_keeper_chat_finished_viewed',
    [EVENT_TYPES.MEMORY_KEEPER_MEMORY_SAVED]: 'app_memory_keeper_memory_saved',
    [EVENT_TYPES.MEMORY_KEEPER_MEMORY_VIEWED]: 'app_memory_keeper_memory_viewed',
    [EVENT_TYPES.MEMORY_KEEPER_CHAPTERS_LOAD_ERROR_VIEWED]: 'app_memory_keeper_chapters_load_error_viewed',
    [EVENT_TYPES.MEMORY_KEEPER_CHAT_LOAD_ERROR_VIEWED]: 'app_memory_keeper_chat_load_error_viewed',
    [EVENT_TYPES.MEMORY_KEEPER_RETRY_CLICKED]: 'app_memory_keeper_retry_clicked',
    [EVENT_TYPES.MEMORY_KEEPER_BOOK_INTEREST_CLICKED]: 'app_memory_keeper_book_interest_clicked',
    [EVENT_TYPES.MEMORY_KEEPER_SHARE_INTEREST_CLICKED]: 'app_memory_keeper_share_interest_clicked',
    [EVENT_TYPES.MEMORY_KEEPER_ONBOARDING_FINISHED]: 'app_memory_keeper_onboarding_finished',
    [EVENT_TYPES.MEMORY_KEEPER_ONBOARDING_CLOSED]: 'app_memory_keeper_onboarding_closed',
    [EVENT_TYPES.MEMORY_KEEPER_ONBOARDING_STEP_VIEWED]: 'app_memory_keeper_onboarding_step_viewed'
});

const DASHBOARD_ITEM_TYPES = Object.freeze({
    BROWSER_EXTENSION: 'browser_extension',
    POCKET_GUIDES: 'pocket_guides'
});

export {
    EVENT_TYPES,
    AMPLITUDE_EVENT_TYPES,
    DASHBOARD_ITEM_TYPES
};
